import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';

class PayGateFrame extends Component {
    
    componentDidMount = () => {
        window.location.href = this.props.paygate_url;
    };

    render() {
        return (
            <div>
                <p style={{marginTop:'100px'}}><CircularProgress size={30} />  Connecting to payment portal...</p>           
            </div>
        );
    }
}

export default PayGateFrame;